import { useStyles } from "@b2bportal/core-themes";
import { APAC_HOTEL_NAME, type ApacHotelsComponent } from "../types";

export const useApacHotelsStyles = (
  componentName: keyof typeof ApacHotelsComponent,
  defaultStyles?: object
) => {
  return useStyles(APAC_HOTEL_NAME, componentName, defaultStyles);
};
